module.exports = __webpack_public_path__ + "media/13-2.23063e18.mp4";